<template>
  <div v-if="!item.hidden" >
    <template
      v-if="hasOneShowingChild(item.children,item) && (!onlyOneChild.children||onlyOneChild.noShowingChildren)&&!item.alwaysShow">
        <el-menu-item
          :index="resolvePath(onlyOneChild.path)"
          @click="redirectUrl(resolvePath(onlyOneChild.path))"
          :class="{'submenu-title-noDropdown':!isNest}">
          <Item
            :icon="onlyOneChild.meta.icon||(item.meta&&item.meta.icon)"
            :title="$t(onlyOneChild.meta.title)"
            :name-count="item.meta && item.meta.nameCount"
            :orderCount="sideCount"/>
        </el-menu-item>
    </template>
    <el-submenu  v-else  ref="subMenu" :index="resolvePath(item.path)" popper-append-to-body>
      <template slot="title">
        <Item
          v-if="item.meta"
          :icon="item.meta && item.meta.icon"
          :title="$t(item.meta.title)"
          :name-count="item.meta && item.meta.nameCount"
          :orderCount="sideCount"/>
      </template>
      <sider-bar-item
        v-for="child in item.children"
        :key="child.path"
        :is-nest="true"
        :item="child"
        :base-path="resolvePath(child.path)"
        class="nest-menu"
      />
    </el-submenu>
  </div>
</template>

<script>
import path from 'path'
import { isExternal } from '$merchantUtils/validate'
import Item from './item'

const { mapState } = Vuex

export default {
  name: 'sider-bar-item',
  components: { Item },
  props: {
    // route object
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ''
    },
    orderCount: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    sideCount() {
      this.$forceUpdate()
      return this.$store.state.common.sideCount
    }
  },
  data() {
    this.onlyOneChild = null
    return {}
  },
  methods: {
    redirectUrl(url) {
      if (this.$route.path === url) {
        const { fullPath } = this.$route
        this.$router.replace({
          path: '/redirect' + fullPath
        })
      } else {
        this.$router.push({
          path: url
        })
      }
    },
    hasOneShowingChild(children = [], parent) {
      const showingChildren = children.filter(item => {
        if (item.hidden) {
          return false
        } else {
          // Temp set(will be used if only has one showing child)
          this.onlyOneChild = item
          return true
        }
      })

      // When there is only one child router, the child router is displayed by default
      if (showingChildren.length === 1) {
        return true
      }

      // Show parent if there are no child router to display
      if (showingChildren.length === 0) {
        this.onlyOneChild = { ...parent, path: '', noShowingChildren: true }
        return true
      }

      return false
    },
    resolvePath(routePath) {
      if (isExternal(routePath)) {
        return routePath
      }
      if (isExternal(this.basePath)) {
        return this.basePath
      }
      return path.resolve(this.basePath, routePath)
    }
  }
}
</script>
